export const CONSTANTS = {
  SCREEN_GROUP: 'system',
  LIST_ALL: 'list-system-all',
} as const;
